<template>
  <div class="servicer-dialog">
    <div class="servicer-info-item">
      <span>顾问：</span>
      <span>{{ name }}</span>
    </div>
    <div class="servicer-info-item">
      <span>联系方式：</span>
      <span>{{ phone }}</span>
    </div>
    <div class="servicer-info-item">如果顾问正忙，可点击“线上咨询’，</div>
    <div class="servicer-info-item">随时为您解答使用中所遇到的问题，</div>
    <div class="servicer-info-item">协助您进行包括打印模板在内的各种配置</div>
    <div class="btn-content">
      <el-button @click="closeDialog">关闭</el-button>
      <el-button type="primary" @click="toChat">线上咨询</el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: "chatInfo",
  props: {
    name: {
      type: String,
    },
    phone: {
      type: String,
    },
  },
  data() {
    return {
        timer: null,
    };
  },
  mounted() {
    this.closePayDialog();
    this.trackView()
  },
  computed: {},
  methods: {
    trackView() {
        window.lib && window.lib.track.view("con_WConlineService", "Func", {
          pageName: "lanqiao_saas_home",
        });
    },
    closeDialog() {
      this.$emit("close");
      clearTimeout(this.timer);
    },
    toChat() {
      this.closeDialog();
      this.openWx();
    },
    closePayDialog() {
      this.timer = setTimeout(() => {
        this.$emit("close");
      }, 1800000);
    },

    openWx() {
      const wxDialogTitle =
        JSON.parse(localStorage.getItem("configMap") || "{}") &&
        JSON.parse(localStorage.getItem("configMap") || "{}")
          .quickClienteleService;

      window.lib && window.lib.track.tap("con_WConlineService", "Func", {
          pageName: "lanqiao_saas_home",
        });

      $.ligerDialog.open({
        title: wxDialogTitle.title,
        modal: false,
        width: 514,
        height: 517,
        url: "/weCom/weCom",
        name: "weCom",
      });
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.servicer-info-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 16px;
  span {
    font-weight: 600;
  }
}
.btn-content {
  display: flex;
  justify-content: center;
  //margin-top: 20px;
}
.btn-content .el-button {
}
</style>
